import React, { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import LineUserIcon from 'LuxKit/Icons/line/LineUserIcon'
import TextLink from 'LuxKit/TextLink'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { generateOfferPageRoom, OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import MessageBanner from 'LuxKit/Banners/MessageBanner'

function TravellingSoloBanner() {
  const offerPageDispatch = useOfferPageDispatch()

  const handleViewSoloPackages = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    offerPageDispatch({
      type: OfferPageActions.setRooms,
      rooms: [generateOfferPageRoom({ adults: 1, children: 0, infants: 0 })],
    })
  }, [offerPageDispatch])

  return (
    <MessageBanner
      kind="promotional-primary"
      icon={<LineUserIcon />}
    >
      <FormattedMessage
        id="q5kNZ7sMypnZcVcrgcwU"
        defaultMessage="<strong>Travelling solo?</strong> — Unlock special rates and tailored inclusions. <link>View packages</link>"
        description="Promotional banner text encouraging solo travellers to view special rates and packages"
        values={{
          strong: (chunks: React.ReactNode) => <strong>{chunks}</strong>,
          link: (chunks: React.ReactNode) => <TextLink underline weight="regular" onClick={handleViewSoloPackages}>{chunks}</TextLink>,
        }}
      />
    </MessageBanner>
  )
}

export default React.memo(TravellingSoloBanner)
